'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*-----------------------
Axios
-----------------------*/

// Post Request Headers

var axiosShopifyPostConfig = exports.axiosShopifyPostConfig = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
    }
};